import React, { useEffect, useState } from "react";
import { Header, Segment, Pagination, Dropdown } from "semantic-ui-react";
import { connect } from "react-redux";
import moment from "moment";

import TitleBar from "../titleBar/titleBar";
import AgGridTable from "../agGridComponent/agGridTable";
import LoadingPlaceholder from "../placeholder/loadingPlaceholder";

import SalesOrderActionButton from "./salesOrderActionButton";
import PdfActionButton from "./pdfActionButton";
import Axios from "axios";
import APP_CONSTANT from "../../config/constants";

import {
  deleteSalesOrder,
  getSalesOrder,
  getGeneratedPdf,
} from "../../redux/actions/salesOrderActions";
import SalesOrderFilterModal from "./salesOrderFilterModal";
import {
  dateFormats,
  messages,
  salesOrderPaginationConfig,
} from "../../utils/constant";
import { headers, titles } from "./salesOrder.constants";

import {
  GET_SALESORDER_REQUEST,
  GET_SALESORDER_SUCCESS,
  GET_SALESORDER_FAIL,
} from "../../redux/types/salesOrderTypes";

function SalesOrderTable(props) {
  const {
    salesOrderData,
    salesOrderLoading,
    deleteSalesOrder,
    deleteSalesOrderIsLoading,
    getGeneratedPdf,
    getSalesOrder,
    // getSalesOrderFilter,
    paginationData,
  } = props;
  const [searchValue, setSearchValue] = useState("");
  const [ClientCode, setClientCode] = useState(null);
  const [BranchCode, setBranchCode] = useState(null);
  const [VehicleCode, setVehicleCode] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [itemCount, setItemCount] = useState(10);
  const [itemsPerPage, setItemsPerPage] = useState(
    salesOrderPaginationConfig[0].pageSize
  );
  const [selectedRows, setSelectedRows] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [showstatusloader, setShowstatusloader] = useState(false);
  const [selectUser, setSelectUser] = useState(false);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [filterOptions, setFilterOptions] = useState({});

  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterData, setFilterData] = useState({
    searchTerm: "",
    clientCode: "",
    branchCode: "",
  });
  const [branchFilterOptions, setBranchFilterOptions] = useState([]);
  const [branchFilterValue, setBranchFilterValue] = useState({});

  let perPageItems = salesOrderPaginationConfig.map((item, index) => {
    return { key: index + 1, text: item.label, value: `${item.pageSize}` };
  });

  // console.log(salesOrderData,'salesOrderData')
  // console.log(getSalesOrder,'getSalesOrder')

  //     const getSalesOrder = (id) => async (dispatch) => {
  //         console.log('get sales order')

  //         // dispatch({ type: GET_SALESORDER_REQUEST });

  //         try {

  //             const headerData = (id) => {
  //                 if(id){
  //                     return {
  //                         "api_token": localStorage.getItem('apiToken'),
  //                         "customer_no": localStorage.getItem('customerNo'),
  //                         "user_id": localStorage.getItem('userId'),
  //                         "reference_number": id
  //                     }
  //                 }else{
  //                     return {
  //                         "api_token": localStorage.getItem('apiToken'),
  //                         "customer_no": localStorage.getItem('customerNo'),
  //                         "user_id": localStorage.getItem('userId'),
  //                     }
  //                 }
  //             }

  //             const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/sales-orders`, headerData(id), {
  //                 headers: {
  //                     'Content-Type': 'application/json',
  //                     "Authorization": localStorage.getItem('apiToken'),
  //                     "Access-Control-Allow-Origin": "*"
  //                 }
  //             });
  // console.log(data,'data')
  //             // return data
  //             dispatch({ type: GET_SALESORDER_SUCCESS, payload: data });

  //         } catch (error) {
  //             // dispatch({ type: GET_SALESORDER_FAIL, payload: error.message })
  //         }
  //     }

  useEffect(() => {
    getSalesOrder(
      itemsPerPage,
      searchValue,
      currentPage,
      null,
      filterData.clientCode,
      filterData.branchCode
    );
    // getSalesOrder()
  }, [getSalesOrder]);

  useEffect(() => {
    setCurrentPage(1);
  }, []);

  useEffect(() => {
    if (paginationData) {
      setItemsPerPage(paginationData.itemsPerPage);
      setItemCount(paginationData.totalItems);
      setTotalPages(paginationData.totalPages);
    }
  }, [paginationData]);

  const handlePaginationChange = (e, { activePage }) => {
    // console.log(activePage)
    setCurrentPage(activePage);
    setLoadingData(true);
    setShowstatusloader(true);
    setRowData([]);
    getSalesOrder(
      itemsPerPage,
      searchValue,
      activePage,
      null,
      ClientCode,
      BranchCode,
      '',
      null,
      VehicleCode
    );
  };

  const handlePagination = (e, data) => {
    e.stopPropagation();
    setRowData([]);
    setCurrentPage(1);
    setItemsPerPage(data.value);
    getSalesOrder(
      data.value,
      searchValue,
      1,
      null,
      ClientCode,
      BranchCode,
      '',
      null,
      VehicleCode
    );
  };

  if (salesOrderLoading) {
    return (
      <React.Fragment>
        <TitleBar
          title={titles.salesOrder || "Sales Order"}
          LinkName="add-salesorder"
        />
        <LoadingPlaceholder />
      </React.Fragment>
    );
  } else if (salesOrderData && salesOrderData.length === 0) {
    return (
      <React.Fragment>
        <TitleBar
          title={titles.salesOrder || "Sales Order"}
          LinkName="add-salesorder"
        />
        <Segment className="m-2">
          <center>
            <Header>{messages.NO_RECORDS_FOUND}</Header>
          </center>
        </Segment>
      </React.Fragment>
    );
  } else {
    let columnDefs = [
      {
        headerName: headers.soNumber || "SO No.",
        field: "soNumber",
        tooltipField: "soNumber",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.soDate || "SO Date",
        field: "soDate",
        tooltipField: "soDate",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.lrNumber || "LR Number",
        field: "lr_no",
        tooltipField: "lr_no",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.lrDate || "LR Date",
        field: "lr_date",
        tooltipField: "lr_date",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.refNo || "Reference No.",
        field: "refNo",
        tooltipField: "refNo",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      // { headerName: 'SO Reciept Date', field: 'soRecieptDate', tooltipField: 'soRecieptDate', enableRowGroup: true, enablePivot: true, filter: true },
      {
        headerName: headers.customerName || "Customer Name",
        field: "customerName",
        tooltipField: "customerName",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      // { headerName: 'Customer Group', field: 'vendorGroup', tooltipField: 'vendorGroup', enableRowGroup: true, enablePivot: true, filter: true },
      {
        headerName: headers.amount || "Amount",
        field: "amount",
        tooltipField: "amount",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.branch || "Branch",
        field: "branch",
        tooltipField: "branch",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.vehicle || "Vehicle",
        field: "vehicle",
        tooltipField: "vehicle",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.remarks || "Remarks",
        field: "remarks",
        tooltipField: "remarks",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.createdOn || "Created On",
        field: "createdOn",
        tooltipField: "createdOn",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.createdBy || "Created By",
        field: "createdBy",
        tooltipField: "createdBy",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.modifiedOn || "Modified On",
        field: "modifiedOn",
        tooltipField: "modifiedOn",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.modifiedBy || "Modified By",
        field: "modifiedBy",
        tooltipField: "modifiedBy",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      // { headerName: 'PDF', field: 'pdf', cellRenderer: 'pdfRenderer',  width: 100, suppressToolPanel: true },
      {
        headerName: headers.edit || "Edit/Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        width: 280,
        suppressToolPanel: true,
        pinned: "right",
      },
    ];

    let frameworkComponents = {
      actionRenderer: SalesOrderActionButton,
      pdfRenderer: PdfActionButton,
    };

    let rowData = [];
    salesOrderData &&
      salesOrderData.forEach((object, index) => {
        let salesOrder = {};
        salesOrder.soNumber = object.so_number;
        salesOrder.soId = object.id;
        salesOrder.lr_no = object.lr_no;
        // salesOrder.lr_date = object.lr_date;
        salesOrder.lr_date = moment(object.lr_date).format(dateFormats.DD_MM_YYYY) === "Invalid date" ? "" : moment(object.lr_date).format(dateFormats.DD_MM_YYYY);
        salesOrder.soDate =
          moment(object.so_date).format(dateFormats.DD_MM_YYYY) ===
            "Invalid date"
            ? ""
            : moment(object.so_date).format(dateFormats.DD_MM_YYYY);
        salesOrder.refNo = object.reference_number;
        salesOrder.soRecieptDate = object.soRecieptDate;
        salesOrder.customerName = object.client_name;
        salesOrder.customerGroup = object.purchasePrice;
        salesOrder.amount = object.so_amount;
        salesOrder.branch = object.branch_name;
        salesOrder.vehicle = object.vehicle_number;
        salesOrder.createdOn = object.created_at;
        salesOrder.createdBy = object.created_by_name;
        salesOrder.modifiedOn = object.updated_at;
        salesOrder.modifiedBy = object.updated_by_name;
        salesOrder.deleteSalesOrder = deleteSalesOrder;
        salesOrder.isLoading = deleteSalesOrderIsLoading;
        salesOrder.getGeneratedPdf = getGeneratedPdf;
        salesOrder.remarks = object.remarks;
        //Extra Data for Edit
        salesOrder.psLineItem = object.po_details;
        salesOrder.isUsed = object.is_used;
        salesOrder.poId = object.poId;
        rowData[index] = salesOrder;
      });

    const handleFilterModelClose = () => {
      setShowFilterModal(false);
    };

    const handleFilterModelOpen = () => {
      setShowFilterModal(true);
    };

    const handleFilter = (values) => {
      getSalesOrder(
        itemsPerPage,
        searchValue,
        1,
        null,
        values.clientCode,
        values.branchCode
      );
    };

    const newPopup = () => {
      props.history.push("/add-salesorder");
    };

    const handleSalesFilterModelOpen = (values) => {
      if (values?.searchString && values?.searchString != "") {
        setSearchValue(values?.searchString);
      }
      getSalesOrder(
        itemsPerPage,
        searchValue,
        currentPage,
        null,
        filterData.clientCode,
        filterData.branchCode
      );
    };

    const filterSales = (payload) => {
      setSearchValue(payload?.search_value);
      setClientCode(payload?.client_code?.toString());
      setBranchCode(payload?.branch_code);
      setVehicleCode(payload?.vehicle_id?.toString());
      getSalesOrder(
        itemsPerPage,
        payload?.search_value,
        1,
        null,
        payload?.client_code?.toString(),
        payload?.branch_code,
        '',
        null,
        payload?.vehicle_id?.toString()

      );
    };

    return (
      <React.Fragment>
        {showFilterModal && (
          <SalesOrderFilterModal
            setDefaultOptions={setDefaultOptions}
            defaultOptions={defaultOptions}
            selectCustomerName={setSelectUser}
            selectUser={selectUser}
            open={showFilterModal}
            setOpen={setShowFilterModal}
            handleClose={handleFilterModelClose}
            setData={setFilterData}
            data={filterData}
            selectedBranch={branchFilterValue}
            setSelectedBranch={setBranchFilterValue}
            branchOptions={branchFilterOptions}
            setBranchOptions={setBranchFilterOptions}
          />
        )}
        <AgGridTable
          customizedSearch={true}
          columnDefs={columnDefs}
          pagination={false}
          rowData={rowData}
          searchValue={searchValue}
          ClientCode={ClientCode}
          BranchCode={BranchCode}
          VehicleCode={VehicleCode}
          link="/add-salesorder"
          baseURL={props}
          newPopup={newPopup}
          hiddenNewPopupBtn={false}
          hiddenImportPopupBtn={true}
          extraComponents={frameworkComponents}
          titleBarTitle={titles.salesOrder || "Sales Order"}
          hiddenFilterButton={false}
          handleFilterOpen={handleFilterModelOpen}
          getFilterSalesOrder={handleSalesFilterModelOpen}
          setFilterValues={filterSales}
        />
        <div className="life-cycle w3-white ui pagination menu">
          <Pagination
            defaultActivePage={currentPage}
            firstItem={null}
            lastItem={null}
            onPageChange={handlePaginationChange}
            pointing
            secondary
            totalPages={totalPages}
          />
          <Dropdown
            options={perPageItems}
            size="mini"
            className="m-1"
            placeholder={salesOrderPaginationConfig[0].label}
            selection
            value={itemsPerPage}
            defaultValue={`${salesOrderPaginationConfig[0].pageSize}`}
            onChange={handlePagination}
            compact
          />
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => ({
  salesOrderData: state.getSalesOrderData.salesOrder.data,
  paginationData: state.getSalesOrderData.salesOrder.pagination,
  salesOrderLoading: state.getSalesOrderData.isLoading,
  deleteSalesOrderIsLoading: state.deleteSalesOrderData.isLoading,
});

export default connect(mapStatetoProps, {
  getSalesOrder,
  deleteSalesOrder,
  getGeneratedPdf,
})(SalesOrderTable);
